import {contactUsSubjectService} from '../services/components/contactussubject.jsx'

function getState(contactUsSubjectState){
    return{
            type:'CONTACTUSSUBJECT_STATE',
            contactUsSubjectState
    }
}


 export const contactSubjectAction=()=>dispatch=>{

    let contactUsSubjectState = [];

    contactUsSubjectService((data,msg) => {


        if (msg === "Failure"){   
          
          contactUsSubjectState = {
               status: 401,
               body: "no data"

           }
       }

     else  if (msg === "success") {
          contactUsSubjectState = {
               status: 200,
               body: data
           }
          console.log(contactUsSubjectState)
       } else {
          contactUsSubjectState = data
       }
       dispatch(getState(contactUsSubjectState))
   })



    // organizationTypeService((data => {
       
    //     (data) ? organizationTypeState = data : console.log('error in fetching data')
    //     console.log("hellostate" + organizationTypeState)
    //     dispatch(getState(organizationTypeState))
    // }))
 }


// WEBPACK FOOTER //
// ./src/actions/getcontactussubject.jsx